import React from "react";
import { useI18n } from "../i18n/I18nProvider";
import { PHILOSOPHY } from "../constants/testIds";
import { Reveal } from "../components/Reveal";
import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Philosophy = () => {
  const { t } = useI18n();
  const paragraphs = t.philosophy.paragraphs;

  return (
    <section
      id="philosophy"
      data-testid={PHILOSOPHY.section}
      className="relative bg-black py-32 md:py-44 lg:py-56 px-6 md:px-10 lg:px-14 border-t border-white/5"
    >
      <div className="mx-auto max-w-[1280px]">
        <Reveal>
          <div className="flex items-center gap-4 text-[10px] tracking-[0.4em] uppercase font-mono text-white/50">
            <span className="w-8 h-px bg-white/30" />
            {t.philosophy.eyebrow}
          </div>
        </Reveal>

        <div className="mt-14 md:mt-20 space-y-10 md:space-y-14">
          {paragraphs.map((p, i) => (
            <motion.p
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: i === paragraphs.length - 1 ? 1 : 0.7, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, ease: EASE, delay: i * 0.08 }}
              className={
                "font-display tracking-display leading-[1.08] max-w-[18ch] md:max-w-[24ch] " +
                "text-[30px] sm:text-[42px] md:text-[58px] lg:text-[72px] " +
                (i === paragraphs.length - 1 ? "text-white" : "text-white/65")
              }
            >
              {p}
            </motion.p>
          ))}
        </div>

        <Reveal delay={0.4}>
          <div className="mt-20 flex items-center gap-4 text-[11px] tracking-[0.32em] uppercase text-white/45 font-mono">
            <span className="w-10 h-px bg-white/30" />
            {t.philosophy.signature}
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Philosophy;
